<div class="banner">
  <div class="banner__content">
    <p class="banner__content__title">Je découvre dès maintenant le Contrat Engagement Jeune&nbsp;!</p>
    <p class="banner__content__description">
      Un parcours personnalisé pour m&apos;aider à définir mon projet professionnel et trouver un emploi
    </p>
  </div>
  <mat-icon class="banner__icon" svgIcon="arrow_next" role="presentation"></mat-icon>
</div>
